import { LARGE_DEVICE_WIDTH_MAX } from "@consts";

export const state = () => ({
	// Basic viewport properties.
	scrollY: 0,
	windowWidth: 0,
	windowHeight: 0,

	topAdHeight: 0,
	visibleHeaderHeight: 0,
	searchMobileHeaderHeight: 0,
});

export const getters = {
	headerClearanceHeight(state) {
		return state.topAdHeight + state.visibleHeaderHeight;
	},
	headerHeight(state, getters, rootState, rootGetters) {
		return state.windowWidth <= LARGE_DEVICE_WIDTH_MAX ? 54 : 112;
	},
};

export const mutations = {
	setWindowDimensions(state, payload) {
		state.windowHeight = payload.windowHeight;
		state.windowWidth = payload.windowWidth;
	},
	setWindowScroll(state, value) {
		state.scrollY = value;
	},
	setTopAdHeight(state, value) {
		state.topAdHeight = value;
	},
	setVisibleHeaderHeight(state, value) {
		state.visibleHeaderHeight = value;
	},
	SET_SEARCH_MOBILE_HEADER_HEIGHT(state, value) {
		state.searchMobileHeaderHeight = value;
	},
};
